export default __webpack_public_path__ + "static/media/Icon-javascript.ce0dce17.svg";